<template>
  <header class="fixed w-full z-30 bg-white">
    <div class="max-w-6xl mx-auto px-4 md:pl-6 md:pr-0">
      <div class="flex items-center justify-between h-20">
        <!-- Site branding -->
        <div class="flex-shrink-0 mr-4">
          <!-- Logo -->
          <router-link to="/" class="block" aria-label="Cruip">
            <img class="w-32" :src="require('@/images/takahashi-name-logo.svg')" alt="高橋章友" />
          </router-link>
        </div>

        <!-- Desktop navigation -->
        <nav class="hidden md:flex md:flex-grow">
          <!-- Desktop menu links -->
          <ul class="flex flex-grow justify-end flex-wrap items-center">
            <li>
              <router-link
                to="/"
                class="text-theme-900 hover:text-theme-800 px-4 py-2 flex items-center transition duration-150 ease-in-out"
                >トップページ</router-link
              >
            </li>
            <li>
              <a
                v-scroll-to="'#cta'"
                class="text-white font-bold bg-theme-100 hover:bg-theme-200 h-20 px-4 py-2 flex items-center transition duration-150 ease-in-out"
                >お申込み</a
              >
            </li>
          </ul>
        </nav>

        <!-- Mobile menu -->
        <div class="md:hidden">
          <!-- Hamburger button -->
          <button
            class="hamburger"
            ref="hamburger"
            :class="{ active: mobileNavOpen }"
            aria-controls="mobile-nav"
            :aria-expanded="mobileNavOpen"
            @click="mobileNavOpen = !mobileNavOpen"
          >
            <span class="sr-only">Menu</span>
            <svg
              class="w-6 h-6 fill-current text-theme-900 hover:text-theme-600 transition duration-150 ease-in-out"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect y="4" width="24" height="2" rx="1" />
              <rect y="11" width="24" height="2" rx="1" />
              <rect y="18" width="24" height="2" rx="1" />
            </svg>
          </button>

          <!-- Mobile navigation -->
          <nav
            id="mobile-nav"
            ref="mobileNav"
            class="absolute top-full z-20 left-0 w-full px-4 sm:px-6 overflow-hidden transition-all duration-300 ease-in-out"
            :style="[
              mobileNavOpen
                ? { maxHeight: $refs.mobileNav.scrollHeight + 'px', opacity: 1 }
                : { maxHeight: 0, opacity: 0.8 },
            ]"
          >
            <ul class="bg-theme-600 px-4 py-2">
              <li>
                <router-link to="/" class="flex text-theme-900 hover:text-theme-800 py-2">トップページ</router-link>
              </li>
              <li>
                <a v-scroll-to="'#cta'" class="flex text-theme-900 hover:text-theme-800 py-2">お申し込み</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "HeaderSimple",
  components: {},
  data: function() {
    return {
      mobileNavOpen: false,
    }
  },
  methods: {
    clickOutside(e) {
      if (!this.mobileNavOpen || this.$refs.mobileNav.contains(e.target) || this.$refs.hamburger.contains(e.target))
        return
      this.mobileNavOpen = false
    },
    keyPress() {
      if (!this.mobileNavOpen || event.keyCode !== 27) return
      this.mobileNavOpen = false
    },
  },
  mounted() {
    document.addEventListener("click", this.clickOutside)
    document.addEventListener("keydown", this.keyPress)
  },
  beforeDestroy() {
    document.removeEventListener("click", this.clickOutside)
    document.removeEventListener("keydown", this.keyPress)
  },
}
</script>

<style scoped>
a {
  cursor: pointer;
}
</style>
